import { Card, Col, Table } from "react-bootstrap";
import React from "react";
import { getIntegratorNameById } from "utils/AppUtils";

import { useTranslation } from "react-i18next";

function PlatformSalesTable({ integrator, data }) {
  const {
    t,
  } = useTranslation();

  const filterData = (data) => {
    return data.filter((row) => row.order_integrator_id === integrator);
  };

  const totalQuantity = filterData(data).reduce((acc, row) => acc + parseInt(row.quantity), 0);
  const totalSum = filterData(data).reduce((acc, row) => acc + parseFloat(row.total), 0);

  return (
    <Card className="strpied-tabled-with-hover">
      <Card.Header>
        <Col>
          <Card.Title as="h4">{getIntegratorNameById(integrator)}</Card.Title>
        </Col>
      </Card.Header>
      <Card.Body className="table-responsive p-0">
        <Table className="table-hover" style={{ tableLayout: "fixed" }}>
          <thead>
            <tr>
              <th>{t("tables.headers.name")}</th>
              <th className="align-text-right">{t("tables.headers.qty")}</th>
              <th className="align-text-right">{t("tables.headers.totalEuro")}</th>
            </tr>
          </thead>
          <tbody>
            {filterData(data).map((row) => (
              <tr key={row.id}>
                <td>{row.product_name}</td>
                <td className="align-text-right">{parseInt(row.quantity)}</td>
                <td className="align-text-right">{row.total.toFixed(2)}</td>
              </tr>
            ))}
            <tr key="total">
              <td>
                <strong>{getIntegratorNameById(integrator)}</strong>
              </td>
              <td className="align-text-right">
                <strong>{totalQuantity}</strong>
              </td>
              <td className="align-text-right">
                <strong>{totalSum.toFixed(2)}</strong>
              </td>
            </tr>
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}

export default PlatformSalesTable;
